<template>
  <div class="content-item">
    <h2 class="heading">Shipping Address</h2>
    <p class="text">
      UPS requires a signature for this package. Truelife happily covers standard shipping costs, however, if the package is returned to the print company, or you need 2 day shipping, we ask that the
      church covers those shipping cost.
    </p>
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <input v-model="shipping_address" type="text" name="textDemo" :class="[shipping_address ? 'form-input' : 'error form-input']" placeholder="Street Address" />
        </div>
      </div>
      <div class="col-md-12">
        <div class="form-group">
          <input v-model="shipping_address2" type="text" name="textDemo" class="form-input" placeholder="Street Address Line 2" />
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <input v-model="shipping_city" type="text" name="textDemo" :class="[shipping_city ? 'form-input' : 'error form-input']" placeholder="City" />
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <input v-model="shipping_state" type="text" name="textDemo" :class="[shipping_state ? 'form-input' : 'error form-input']" placeholder="State / Province" />
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <input v-model="shipping_zipcode" type="text" name="textDemo" :class="[shipping_zipcode ? 'form-input' : 'error form-input']" placeholder="Postal / Zip Code" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { debounce, isFunction } from 'lodash';
import { empty } from '@/utils';
export default {
  name: 'Step12',
  props: {
    value: {
      type: Object,
    },
    source: {
      type: Object,
    },
    step: {
      type: Number,
    },
  },
  data() {
    return {
      shipping_address: '',
      shipping_address2: '',
      shipping_city: '',
      shipping_state: '',
      shipping_zipcode: '',
    };
  },
  computed: {
    isError() {
      return empty(this.shipping_address) || empty(this.shipping_city) || empty(this.shipping_state) || empty(this.shipping_zipcode);
    },
  },
  watch: {
    isError: {
      handler(value) {
        if (isFunction(this.doEmitErrorDebouned)) {
          this.doEmitErrorDebouned(value);
        } else {
          this.doEmitError(value);
        }
      },
      immediate: true,
    },
  },
  created() {
    this.doEmitErrorDebouned = debounce(this.doEmitError, 400);
  },
  methods: {
    submit() {
      if (this.isError) {
        this.$emit('onAnimated', [this.isError, this.step, 'Shipping address is required.']);
      } else {
        this.$emit('input', {
          ...this.value,
          shipping_address: this.shipping_address,
          shipping_address2: this.shipping_address2,
          shipping_city: this.shipping_city,
          shipping_state: this.shipping_state,
          shipping_zipcode: this.shipping_zipcode,
        });
      }
    },
    doEmitError(value) {
      this.$emit('onInvalid', [value, this.step, 'Shipping address is required.']);
    },
  },
};
</script>
